import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Content extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get homePageSEO() {
    return get(this, '_strona_glowna___seo.value[0].model');
  }

  get report() {
    return get(this, '_raport_multimedialny.value[0]');
  }

  get annualReport() {
    return get(this, '_raport_roczny.value[0]');
  }

  get companyResultsText() {
    return get(this, '_wyniki_spolki___text.value', '');
  }

  get companies() {
    return get(this, '_nasze_spolki.value', []);
  }

  get homePageManagement() {
    return get(this, '_strona_glowna___wladze.value');
  }

  get homePageShareholders() {
    return get(this, '_strona_glowna___akcjonariusze.value[0]');
  }

  get homePageAwards() {
    return get(this, '_strona_glowna___nagrody.value');
  }

  get homePageProducts() {
    return get(this, '_strona_glowna___nasze_produkty.value');
  }

  get announcementSEO() {
    return get(this, '_komunikat___seo.value[0].model');
  }

  get announcementFilesHeader() {
    return get(this, '_komunikat___naglowek_plikow.value', '');
  }

  get announcementFiles() {
    return get(this, '_komunikat___pliki.value', []);
  }

  get corporateGovernanceSEO() {
    return get(this, '_lad_korporacyjny___seo.value[0].model');
  }

  get corporateGovernanceImage() {
    return get(this, '_lad_korporacyjny___zdjecie.value[0].url', '');
  }

  get corporateGovernanceText() {
    return get(this, '_lad_korporacyjny___opis.value', '');
  }

  get corporateGovernanceFilesHeader() {
    return get(this, '_lad_korporacyjny___naglowek_plikow.value', '');
  }

  get corporateGovernanceFiles() {
    return get(this, '_lad_korporacyjny___pliki.value', []);
  }

  get rodoPolicySEO() {
    return get(this, '_polityka_rodo___seo.value[0].model');
  }

  get rodoPolicyImage() {
    return get(this, '_polityka_rodo___zdjecie.value[0].url', '');
  }

  get rodoPolicyText() {
    return get(this, '_polityka_rodo___opis.value', '');
  }

  get rodoPolicyAccordionList() {
    return get(this, '_polityka_rodo___lista.value', []);
  }

  get rodoPolicyLinks() {
    return get(this, '_polityka_rodo___linki.value', []);
  }

  get zszPolicySEO() {
    return get(this, '_polityka_zsz___seo.value[0].model');
  }

  get zszPolicyImage() {
    return get(this, '_polityka_zsz___zdjecie.value[0].url', '');
  }

  get zszPolicyText() {
    return get(this, '_polityka_zsz___opis.value', '');
  }

  get zszPolicyAccordionList() {
    return get(this, '_polityka_zsz___lista.value', []);
  }

  get zszPolicyLinks() {
    return get(this, '_polityka_zsz___linki.value', []);
  }

  get missionAndVisionMainContent() {
    return get(this, '_misja_i_wizja___glowny_opis.value', []);
  }

  get missionAndVisionValuesWeBelieve() {
    return get(this, '_misja_i_wizja___wartosci_w_ktore_wierzymy.value', []);
  }

  get missionAndVisionImage() {
    return get(this, '_misja_i_wizja___zdjecie.value[0].url', '');
  }

  get financialResultsSEO() {
    return get(this, '_wyniki_finansowe___seo.value[0].model');
  }

  get financialResultsYearlyData() {
    return get(this, '_wyniki_finansowe___dane_roczne.value[0].url', '');
  }

  get financialResultsQuarterlyData() {
    return get(
      this,
      '_wyniki_finansowe___wybrane_dane_kwartalne.value[0].url',
      ''
    );
  }

  get financialResultsOnlyData() {
    return get(this, '_wyniki_finansowe___tabela_bez_tytulu.value[0].url', '');
  }

  get financialResultsEntries() {
    return get(this, '_wyniki_finansowe___sprawozdania__sidebar_.value', '');
  }

  get missionAndVisionSEO() {
    return get(this, '_misja_i_wizja___seo.value[0].model');
  }

  get ourCompaniesSEO() {
    return get(this, '_nasze_spolki___seo.value[0].model');
  }

  get companiesLogos() {
    return get(this, '_spolki___logotypy.value', []);
  }

  get strategySEO() {
    return get(this, '_strategia___seo.value[0].model');
  }

  get synergySEO() {
    return get(this, '_synergia___seo.value[0].model');
  }

  get historySEO() {
    return get(this, '_historia___seo.value[0].model');
  }

  get authoritiesSEO() {
    return get(this, '_wladze___seo.value[0].model');
  }

  get teamOfExpertsSEO() {
    return get(this, '_zespol_ekspertow___seo.value[0].model');
  }

  get caseStudiesSEO() {
    return get(this, '_case_studies___seo.value[0].model');
  }

  get jobOffersSEO() {
    return get(this, '_oferty_pracy___seo.value[0].model');
  }

  get csrSEO() {
    return get(this, '_csr___seo.value[0].model');
  }

  get csrText() {
    return get(this, '_csr___opis.value', '');
  }

  get csrImage() {
    return get(this, '_csr___zdjecie.value[0].url', '');
  }

  get pressRoomSEO() {
    return get(this, '_press_room___seo.value[0].model');
  }

  get pressRoomContactPerson() {
    return get(this, '_press_room___osoba_kontaktowa.value[0]', {});
  }

  get newsSEO() {
    return get(this, '_aktualnosci___seo.value[0].model');
  }

  get reportsSEO() {
    return get(this, '_raporty___seo.value[0].model');
  }

  get contactSEO() {
    return get(this, '_kontakt___seo.value[0].model');
  }

  get PrivacyPolicySEO() {
    return get(this, '_polityka_prywatnosci___seo.value[0].model');
  }

  get PrivacyPolicyHeader() {
    return get(this, '_polityka_prywatnosci___naglowek.value', '');
  }

  get PrivacyPolicyText() {
    return get(this, '_polityka_prywatnosci___text.value', '');
  }

  get TermsOfUseSEO() {
    return get(this, '_regulamin___seo[0].model');
  }

  get TermsOfUseHeader() {
    return get(this, '_regulamin___naglowek.value', '');
  }

  get TermsOfUseText() {
    return get(this, '_regulamin___tekst.value', '');
  }

  get StrategyComment() {
    return get(this, '_strategia___komentarz.value[0]', []);
  }

  get StrategySpecialization() {
    return get(this, '_strategia___specializacje.value', []);
  }

  get StrategyBackgroundImage() {
    return get(this, '_strategia___zdjecie_tlo.value[0].url', '');
  }

  get StrategyInfoImage() {
    return get(this, '_strategia___zdjecie_zajawka.value[0].url', '');
  }

  get StrategyInfoTitle() {
    return get(this, '_strategia___tytul_zajawki.value', '');
  }

  get StrategyInfoText() {
    return get(this, '_strategia___tresc_zajawki.value', '');
  }

  get SynergyComment() {
    return get(this, '_synergia___komentarz.value[0]', []);
  }

  get SynergyShortCompanyDescription() {
    return get(this, '_synergia___krotki_opis_spolki.value', []);
  }

  get SynergyShortGroupDescription() {
    return get(this, '_synergia___krotki_opis_grupy.value', '');
  }

  get SynergyBackgroundImage() {
    return get(this, '_synergia___zdjecie_tlo.value[0].url', '');
  }

  get SynergyInfoImage() {
    return get(this, '_synergia___zdjecie_zajawka.value[0].url', '');
  }

  get SynergyInfoText() {
    return get(this, '_synergia___tresc_zajawki.value', '');
  }

  get SynergyInfoTitle() {
    return get(this, '_synergia___tytul_zajawki.value', '');
  }

  get ForInvestors() {
    return get(this, '_dlainwestorow___link.value', []);
  }

  get ForInvestorsTitle() {
    return get(this, '_dlainwestorow___tytul.value', '');
  }

  get ForInvestorsHiddenNav() {
    return !!get(
      this,
      '_dlainwestorow___widocznosc_w_menu.value[0].name',
      false
    );
  }

  get ForInvestorsUpcomingEvents() {
    return get(this, '_dla_inwestorow___nadchodzace_wydarzenia.value', []);
  }

  get ForInvestorsBannerUrl() {
    return get(this, '_dlainwestorow___baner.value[0].url', '');
  }

  get ForInvestorsBannerSlogan() {
    return get(this, '_dlainwestorow___baner_slogan.value', '');
  }

  get ForInvestorsBannerText() {
    return get(this, '_dlainwestorow___baner_tekst.value', '');
  }

  get ForInvestorsBannerHref() {
    return get(this, '_dlainwestorow___baner_href.value', '');
  }

  get ForInvestorsBannerYear() {
    return get(this, '_dlainwestorow___baner_rok.value', '');
  }

  get ForInvestorsNewsletterTitle() {
    return get(this, '_dlainwestorow___newsletter_tytul.value', '');
  }

  get ForInvestorsNewsletterSubtitle() {
    return get(this, '_dlainwestorow___newsletter_podtytul.value', '');
  }

  get ForInvestorsNewsletterAgreement() {
    return get(this, '_dlainwestorow___newsletter_zgoda.value', '');
  }

  get ForInvestorsContact() {
    return get(this, '_dlainwestorow___kontakt.value[0]', {});
  }

  get infoAboutCompanySEO() {
    return get(this, '_informacje_o_spolce___seo.value[0].model');
  }

  get infoAboutCompanyImage() {
    return get(this, '_informacje_o_spolce___zdjecie.value[0].url', '');
  }

  get infoAboutCompanyText() {
    return get(this, '_informacje_o_spolce___opis.value', '');
  }

  get infoAboutCompanyFilesHeader() {
    return get(this, '_informacje_o_spolce___naglowek_plikow.value', '');
  }

  get infoAboutCompanyFiles() {
    return get(this, '_informacje_o_spolce___pliki.value', []);
  }

  get generalMeetingsSEO() {
    return get(this, '_walne_zgromadzenia___seo.value[0].model');
  }

  get periodicReportsSEO() {
    return get(this, '_raporty_okresowe___seo.value[0].model');
  }

  get currentReportsSEO() {
    return get(this, '_raporty_biezace___seo.value[0].model');
  }

  get calendariumSEO() {
    return get(this, '_kalendarium___seo.value[0].model');
  }

  get boardOfDirectors() {
    return get(this, '_sklad_rady_nadzorczej.value');
  }
  get landingPageJobOffers() {
    return get(this, '_ladning_page_oferty_pracy.value');
  }

  get InformationClauseSEO() {
    return get(this, '_klauzula_infomacyjna___seo.value[0].model');
  }

  get InformationClauseHeader() {
    return get(this, '_klauzula_informacyjna___naglowek.value', '');
  }

  get InformationClauseText() {
    return get(this, '_klauzula_informacyjna___tekst.value', '');
  }

  get IssueOfShares() {
    return get(this, '_emisja_akcji.value[0]');
  }

  get Whistleblowing() {
    return get(this, '_zglaszanie_nieprawidlowosci___tekst.value', '');
  }

  get IsIssueOfSharesActive() {
    return get(this, '_czy_emisja_aktywna.value[0].name');
  }

  get IsIssueOfSharesActiveInMenu() {
    return get(this, '_czy_emisja_w_menu_aktywna.value[0].name');
  }

  get modalContent() {
    return get(this, '_modal_text.value', '');
  }

  get presentations() {
    return get(this, '_prezentacje_inwestorskie');
  }
}



// WEBPACK FOOTER //
// ./src/models/Content.model.js